import { Route, Routes } from "react-router-dom";
import FooterComponent from "./components/footer.component";
import Header from "./components/header/header.component";
import LoginPage from "./pages/login.page";
import AuthProvider from "./providers/auth.provider";
import { AuthenticatedRoutes } from "./routes";
import "./styles/button.styles.css";
import RegisterPage from "./pages/register.page";

const Main = () => {
  return (
    <div className={`app`}>
      {/*
        Do not move auth provider from here.
        The Mobile header component needs this.
        */}
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<AuthenticatedRoutes />} />
        </Routes>
        <FooterComponent />
      </AuthProvider>
    </div>
  );
};

export default Main;
